import angular from 'angular';

import _css from './od-listing-card.less';

module.exports = angular.module('market.components.od-listing-card', [])
.component('odListingCard', {
  bindings: {
    listing: '<',
  },
  template: require('./od-listing-card.jade')(),
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/components/od-listing-card.js
 **/